import React, { useState } from "react";
import axios from 'axios';
import { useAuth } from '../auth'

export const HttpProviderContext = React.createContext();

const HttpProvider = ({ children }) => {
    const { state } = useAuth();

    const customAxios = React.useMemo(() => {
        const _customAxios = axios.create({
            baseURL: process.env.REACT_APP_API_URL,
            headers: {
                "Access-Control-Allow-Origin": "*"
            }
        })

        _customAxios.interceptors.request.use(
            config => {
                if (!config.headers.authorization) {
                    config.headers.authorization = `Bearer ${state.token || state.defaultToken}`
                }
                return config;
            },
            error => {
                return Promise.reject(error)
            }
        )

        _customAxios.interceptors.response.use(
            response => {
                return response.data;
            },
            error => {
                return Promise.reject(error)
            }
        )

        return _customAxios;
    }, [state.token, state.defaultToken])

    return (
        <HttpProviderContext.Provider
            value={customAxios}
        >
            {
                children
            }
        </HttpProviderContext.Provider>
    )
}

export default HttpProvider;